import { useState } from 'react';

import type { ReactNode } from 'react';

import loadable from '@loadable/component';

import { useFlag } from '@/features/unleash';

import type { Brokerage } from '../../hooks/useBrokerSearch';
import { PUBLIC_SWS_ENV } from '@/constants/env';

const LinkingInstructionsModal = loadable(
  () => import('./LinkingInstructionsModal'),
  {
    resolveComponent: (component) => component.LinkingInstructionsModal,
  }
);

const InstructionsTrading212 = loadable(() => import('./LinkingInstructions'), {
  resolveComponent: (component) => component.InstructionsTrading212,
});

// const InstructionsIBKR = loadable(() => import('./LinkingInstructions'), {
//   resolveComponent: (component) => component.InstructionsIBKR,
// });

interface Props {
  brokerage: Brokerage;
  children: ReactNode;
  onClose: () => void;
}

const providers = ['passiv', 'plaid'] as const;

type Provider = (typeof providers)[number];

const isProvider = (name: string): name is Provider => {
  return providers.includes(name as Provider);
};

/**
 * Brokerages that should show linking instructions
 * This list is for testing purposes only and should be removed when/if the feature is fully rolled out
 */
const brokerIdTrading212 =
  PUBLIC_SWS_ENV === 'prod'
    ? 'ae0037d4-ec68-4dbe-92dc-75bb9c6eeb71'
    : 'ac9a5d8f-6566-494c-8813-766052612c0d';

const brokerList = [brokerIdTrading212];

export const LinkingWithInstructions = ({
  brokerage,
  children,
  onClose,
}: Props) => {
  const featureFlag = useFlag({ name: 'mono-portfolio-linking-instructions' });

  const canAccessLinkingInstructions =
    featureFlag.enabled && featureFlag.flagsReady;

  const [seenInstructions, setSeen] = useState(false);

  if (!isProvider(brokerage.provider.name)) return null;

  if (
    canAccessLinkingInstructions &&
    brokerList.includes(brokerage.id) &&
    seenInstructions === false
  ) {
    return (
      <LinkingInstructionsModal
        brokerage={brokerage}
        providerName={brokerage.provider.name}
        onClose={onClose}
        onConfirm={() => setSeen(true)}
      >
        {brokerage.id === brokerIdTrading212 && (
          <InstructionsTrading212 brokerage={brokerage} />
        )}
        {/* {brokerage.id === 'b9bfeb5d-37f0-4000-a228-5c27093348f1' && (
          <InstructionsIBKR brokerage={brokerage} />
        )} */}
      </LinkingInstructionsModal>
    );
  }

  return children;
};
